import {
  SVG_CIRCLE_SIZE_MM,
  getNodeColorPerScanType,
} from "../DrawingTool/drawing-utils";
import { SequenceMapData } from "./types";

const imageToBase64 = async (url: string): Promise<string> => {
  const response = await fetch(url);
  const blob = await response.blob();
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise((resolve) => {
    reader.onload = () => resolve(reader.result as string);
  });
};

const transformToFloorplanPixels = (
  srcX: number,
  srcY: number,
  mmScaleFactor: number,
  originX: number,
  originY: number,
) => ({
  x: (1 / mmScaleFactor) * srcX + originX,
  y: (1 / mmScaleFactor) * srcY + originY,
});

const escapeXml = (str: string): string =>
  str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");

export const generateSequenceMapSvg = async (
  sequence: SequenceMapData,
  dotSize?: number,
): Promise<string> => {
  const { floorplan, scenes } = sequence;
  const imageData = await imageToBase64(floorplan.url);
  const floorName = escapeXml(floorplan.spaceName);
  const dotRadius =
    (SVG_CIRCLE_SIZE_MM / (2 * floorplan.mmScaleFactor)) * (dotSize || 1);

  const sceneElements = scenes
    .map((scene) => {
      const { x, y } = transformToFloorplanPixels(
        scene.x,
        scene.y,
        floorplan.mmScaleFactor,
        floorplan.originX,
        floorplan.originY,
      );
      const color = getNodeColorPerScanType(scene.scanType);
      return `      <circle id="scene-${escapeXml(
        scene.id,
      )}" cx="${x}" cy="${y}" r="${dotRadius}" fill="${color}" opacity="0.85" />`;
    })
    .join("\n");

  return [
    `<?xml version="1.0" encoding="UTF-8"?>`,
    `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 ${floorplan.width} ${floorplan.height}" width="${floorplan.width}" height="${floorplan.height}">`,
    `  <g id="${floorName}">`,
    `    <image href="${imageData}" width="${floorplan.width}" height="${floorplan.height}" />`,
    `    <g id="sequence_points">`,
    sceneElements,
    `    </g>`,
    `  </g>`,
    `</svg>`,
  ].join("\n");
};

export const downloadSvgFile = (svgContent: string, filename: string) => {
  const blob = new Blob([svgContent], { type: "image/svg+xml" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
